import { Row, Col, Button, Table, Spin, message } from 'antd'
import { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hrStepper, getAllUsersCount, getUsersToApprove, stepperMoving } from '../../stores/actions';
import { postApi } from '../../../../shared/src/apis';
import { LoadingOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { OutPutResult, exportToCSV } from '@operations/shared';

interface IRootState {
    [key: string]: any;
    usersCount: number,
    hrStep: number,
    usersToApprove: any,
}
interface Props {
    apiLink: string,
    dataKey: string
}
const columns: any = [
    {
        title: 'User ID',
        dataIndex: 'userID',
    },
    {
        title: 'Reasons',
        dataIndex: 'message',

    },
];
export default function ConfirmationCollection(props: Props) {
    const [loader, setLoader] = useState(false)
    const [reason, setReasons] = useState([]);
    const [errorMode, setErrorMode] = useState(false);
    const [numOfLostCollections, setNumOfLostCollections] = useState(0);
    const [numOfSuccessLostCollections, setNumOfSuccessLostCollections] = useState(0);
    const [numOfFailedLostCollections, setNumOfFailedLostCollections] = useState(0);
    const [hideTable, setHideTable] = useState(false);
    const [rejectedProducts, setRejectedProducts] = useState([]);

    const dispatch = useDispatch();
    const dataSheet: any = useSelector<IRootState>(state => state.actionsReducer.dataSheet);


    const createProducts = useCallback(async (dataSheet: any) => {
        let usersCount;
        const data = {
            [props.dataKey]: dataSheet.sheetData
        }

        try {
            const apiData: any = await dispatch(postApi(props.apiLink, data));

            const res = await apiData.payload;

            if (res.status === 406 || res.status === 200) {

                if (res?.rejectedCollectionsCount === 0) {
                    setHideTable(true);
                }
                setNumOfLostCollections(res?.totalLostCollectionsCount)
                setNumOfSuccessLostCollections(res?.acceptedCollectionsCount);
                setNumOfFailedLostCollections(res?.rejectedCollectionsCount);
                dispatch(getAllUsersCount(usersCount));
                dispatch(getUsersToApprove(res?.data?.sheetData))
                setReasons(res?.rejectedCollections);
                if (res?.status === 406 && res?.acceptedCollectionsCount !== 0) {
                    message.error(res?.message + ' the success means the users have no issues')
                }
                setRejectedProducts(res?.rejectedCollections)

                return
            };
            setErrorMode(true);
        } catch (error) {
            console.log(error)
            setErrorMode(true)
        } finally {
            setLoader(false);

        }
    }, [props, dispatch]);
    useEffect(() => {
        setLoader(true)
        createProducts(dataSheet)
    }, [createProducts, dataSheet])

    const antIcon = <LoadingOutlined style={{ fontSize: 100, color: '#7CC58F' }} spin />;
    return (
        <>
            <div className="approveUsers" style={{ textAlign: 'center' }}>


                {loader ? <div className='waiting'>
                    <Spin indicator={antIcon} style={{ margin: '20px 0' }} />
                    <p className='check'>Verifying the file and loading the data ...</p>
                    <p className='checkHint'>Wait... This process may take several minutes</p>
                </div> : errorMode ? <OutPutResult status={'error'} subTitle={' '} title={'Sorry, Data upload failed'} btnClick={() => dispatch(hrStepper(0))}
                /> :
                    <div className="uploaded" style={{}}>
                        <Row style={{ textAlign: 'center', margin: '20px 0' }}>
                            <Col span={6}>
                                <div className="flex items-center p-3 all" style={{}}>
                                    All {numOfLostCollections ? numOfLostCollections : 0}
                                    <CheckCircleOutlined className='mx-1' />   </div>
                            </Col>

                            <Col span={6}>
                                <div className="flex items-center p-3 failed" style={{}}>
                                    Failed {numOfFailedLostCollections ? numOfFailedLostCollections : 0}
                                    <CheckCircleOutlined className='mx-1' />   </div>
                            </Col>

                            <Col span={6}>
                                <div className="flex items-center p-3 successes" style={{}}>
                                    Succeeded {numOfSuccessLostCollections ? numOfSuccessLostCollections : 0}
                                    <CheckCircleOutlined className='mx-1' />   </div>
                            </Col>
                            {numOfFailedLostCollections !== 0 && <Col span={6} className='flex items-center justify-end'>
                                <Button className='down' onClick={() => exportToCSV(rejectedProducts, 'Rejected users')}>Download</Button>
                            </Col>}
                        </Row>
                        <div className="">
                            {!hideTable ? <Table columns={columns} dataSource={reason} pagination={false} /> : <OutPutResult status={'success'} subTitle={' '} title={`The lost collections created successfully`} btnClick={() => dispatch(hrStepper(0))}
                            />}
                        </div>
                    </div>
                }

                <Button className='reUpload' onClick={() => dispatch(stepperMoving(0))}>Re-upload file</Button>
            </div>
        </>
    )
}
